import { useAuth } from '../../App';
import PartnerManagement from './PartnerManagement';

export default function Partners() {
  const { token } = useAuth();
  
  return (
    <div className="p-4 lg:p-8 pb-20 lg:pb-8">
      <PartnerManagement token={token} />
    </div>
  );
}
